
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service.do",
      function () {
        return require("private-next-pages/customer-service.do/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service.do"])
      });
    }
  